// src/views/sistema/CadastroJobs.jsx
import React, { useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import condominiosService from "../../services/condominiosService";

const fmtDT = d => { try { if(!d) return "—"; return new Date(d).toLocaleString("pt-BR"); } catch{ return d||"—"; } };

const STATUS_BADGE = {
  Sucesso:    { bg:"#DCFCE7", color:"#166534" },
  Erro:       { bg:"#FEE2E2", color:"#991B1B" },
  Parcial:    { bg:"#FEF3C7", color:"#92400E" },
  Executando: { bg:"#DBEAFE", color:"#1D4ED8" },
  Aguardando: { bg:"#F1F5F9", color:"var(--gray-500)" },
};

const BANCOS = ["EFÍ / EfiPay","Sicoob","Itaú","Bradesco","Santander","BB","Caixa","Outro"];

export default function CadastroJobs() {
  const [condominios, setCondominios] = useState([]);
  const [idCondo,     setIdCondo]     = useState("");
  const [jobs,        setJobs]        = useState([]);
  const [aba,         setAba]         = useState("api");
  const [logs,        setLogs]        = useState([]);
  const [saving,      setSaving]      = useState(false);
  const [executando,  setExecutando]  = useState(false);
  const [loadingLogs, setLoadingLogs] = useState(false);
  const [msg,         setMsg]         = useState("");

  useEffect(() => {
    condominiosService.listar().then(r => setCondominios(r.data||[])).catch(()=>{});
  }, []);

  const carregar = useCallback(async (condo) => {
    if (!condo) return;
    try {
      const r = await api("GET", `/jobs/${condo}`);
      setJobs(r.data||[]);
    } catch(e) {}
  }, []);

  useEffect(() => { carregar(idCondo); }, [idCondo]);

  const carregarLogs = async (nmJob) => {
    setLoadingLogs(true);
    try {
      const r = await api("GET", `/jobs/${idCondo}/${nmJob}/logs`);
      setLogs(r.data||[]);
    } catch(e) {}
    setLoadingLogs(false);
  };

  const jobAtual = jobs.find(j => j.nmJob === (aba==="api" ? "job-boleto-api" : "job-boleto-arquivo"));
  const cfg = jobAtual?.configuracao || {};

  const setConfig = (field, value) => {
    setJobs(prev => prev.map(j => {
      if (j.nmJob !== jobAtual?.nmJob) return j;
      return { ...j, configuracao: { ...j.configuracao, [field]: value } };
    }));
  };

  const setAtivo = (value) => {
    setJobs(prev => prev.map(j =>
      j.nmJob === jobAtual?.nmJob ? { ...j, ativo: value } : j
    ));
  };

  const salvar = async () => {
    if (!idCondo || !jobAtual) return;
    setSaving(true); setMsg("");
    try {
      await api("POST", `/jobs/${idCondo}/${jobAtual.nmJob}`, {
        ativo: jobAtual.ativo ? 1 : 0,
        configuracao: jobAtual.configuracao,
      });
      setMsg("✅ Configuração salva com sucesso!");
      carregar(idCondo);
    } catch(e) { setMsg("❌ " + e.message); }
    setSaving(false);
  };

  const executarManual = async () => {
    if (!idCondo || !jobAtual) return;
    setExecutando(true); setMsg("");
    try {
      const r = await api("POST", `/jobs/${idCondo}/${jobAtual.nmJob}/executar`);
      setMsg("⏳ " + r.message);
      setTimeout(() => { carregar(idCondo); carregarLogs(jobAtual.nmJob); }, 3000);
    } catch(e) { setMsg("❌ " + e.message); }
    setExecutando(false);
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">
            <i className="bi bi-gear-wide-connected me-2" style={{color:"var(--primary)"}}/>
            Cadastro de Jobs
          </h1>
          <p className="page-subtitle">Automação de baixa de boletos via API ou arquivo de retorno CNAB</p>
        </div>
      </div>

      <div style={{padding:16}}>
        {/* Seletor de Condomínio */}
        <div className="form-section" style={{marginBottom:16,maxWidth:400}}>
          <label className="form-label">Condomínio</label>
          <select className="form-select" value={idCondo} onChange={e=>{ setIdCondo(e.target.value); setLogs([]); setMsg(""); }}>
            <option value="">— Selecione —</option>
            {condominios.map(c=><option key={c.id} value={c.id}>{c.nmFantasia||c.nmCondominio}</option>)}
          </select>
        </div>

        {idCondo && (
          <>
            {/* Abas */}
            <div style={{display:"flex",gap:0,marginBottom:16,borderBottom:"2px solid #E2E8F0"}}>
              {[
                { id:"api",    label:"Job Boleto — API",    icon:"bi-cloud-arrow-down" },
                { id:"arquivo",label:"Job Boleto — Arquivo",icon:"bi-folder2-open" },
              ].map(t=>(
                <button key={t.id}
                  onClick={()=>{ setAba(t.id); setLogs([]); setMsg(""); }}
                  style={{
                    padding:"10px 24px", border:"none", background:"transparent",
                    fontWeight:600, fontSize:13, cursor:"pointer",
                    borderBottom: aba===t.id?"3px solid #1B3A6B":"3px solid transparent",
                    color: aba===t.id?"#1B3A6B":"#64748B",
                  }}>
                  <i className={`bi ${t.icon} me-2`}/>{t.label}
                </button>
              ))}
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
              {/* Configuração */}
              <div className="form-section">
                {/* Status atual */}
                {jobAtual?.ultimaExecucao && (
                  <div style={{background:"var(--bg-surface-alt)",borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:12}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{color:"var(--gray-500)"}}>Última execução:</span>
                      <span style={{fontWeight:600}}>{fmtDT(jobAtual.ultimaExecucao)}</span>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:4}}>
                      <span style={{color:"var(--gray-500)"}}>Status:</span>
                      {(() => {
                        const st = jobAtual.statusUltima||"Aguardando";
                        const badge = STATUS_BADGE[st]||STATUS_BADGE.Aguardando;
                        return <span style={{fontSize:11,padding:"2px 8px",borderRadius:10,fontWeight:700,background:badge.bg,color:badge.color}}>{st}</span>;
                      })()}
                    </div>
                  </div>
                )}

                {/* Toggle ativo */}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,padding:"12px 16px",background:jobAtual?.ativo?"#D1FAE5":"#FEE2E2",borderRadius:8}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13,color:jobAtual?.ativo?"#166534":"#991B1B"}}>
                      {jobAtual?.ativo ? "✅ Job Ativo" : "⏸ Job Inativo"}
                    </div>
                    <div style={{fontSize:11,color:"var(--gray-500)"}}>
                      {jobAtual?.ativo ? "Executando automaticamente" : "Clique para ativar"}
                    </div>
                  </div>
                  <div className="form-check form-switch mb-0">
                    <input className="form-check-input" type="checkbox" role="switch"
                      checked={!!jobAtual?.ativo}
                      onChange={e=>setAtivo(e.target.checked)}
                      style={{width:48,height:24,cursor:"pointer"}}/>
                  </div>
                </div>

                {/* Campos específicos por modo */}
                {aba === "api" ? (
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label">Banco *</label>
                      <select className="form-select" value={cfg.banco||""} onChange={e=>setConfig("banco",e.target.value)}>
                        <option value="">— Selecione o banco —</option>
                        {BANCOS.map(b=><option key={b} value={b}>{b}</option>)}
                      </select>
                      <small className="text-muted">Banco configurado nas Contas Bancárias</small>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Intervalo (minutos) *</label>
                      <input type="number" min="5" max="1440" className="form-control"
                        value={cfg.intervaloMinutos||10}
                        onChange={e=>setConfig("intervaloMinutos",e.target.value)}/>
                      <small className="text-muted">Mínimo: 5 min</small>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Limite por execução</label>
                      <input type="number" min="1" max="200" className="form-control"
                        value={cfg.limitePorVez||20}
                        onChange={e=>setConfig("limitePorVez",e.target.value)}/>
                      <small className="text-muted">Boletos por vez</small>
                    </div>
                    <div className="col-12">
                      <div style={{background:"var(--bg-highlight)",borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8"}}>
                        <i className="bi bi-info-circle me-2"/>
                        <strong>Como funciona:</strong> A cada {cfg.intervaloMinutos||10} minutos, busca até {cfg.limitePorVez||20} boletos com status "Registrado", consulta a API do banco e realiza a baixa automática dos que foram pagos.
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label">Pasta de Entrada *</label>
                      <input type="text" className="form-control"
                        placeholder="Ex: C:\Retornos\entrada ou /home/retornos/entrada"
                        value={cfg.pastaEntrada||""}
                        onChange={e=>setConfig("pastaEntrada",e.target.value)}/>
                      <small className="text-muted">Pasta onde os arquivos .ret serão depositados</small>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Pasta de Saída *</label>
                      <input type="text" className="form-control"
                        placeholder="Ex: C:\Retornos\processados ou /home/retornos/processados"
                        value={cfg.pastaSaida||""}
                        onChange={e=>setConfig("pastaSaida",e.target.value)}/>
                      <small className="text-muted">Após processar, o arquivo é movido para cá com timestamp</small>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Intervalo (minutos) *</label>
                      <input type="number" min="5" max="1440" className="form-control"
                        value={cfg.intervaloMinutos||15}
                        onChange={e=>setConfig("intervaloMinutos",e.target.value)}/>
                    </div>
                    <div className="col-12">
                      <div style={{background:"var(--bg-highlight)",borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8"}}>
                        <i className="bi bi-info-circle me-2"/>
                        <strong>Como funciona:</strong> A cada {cfg.intervaloMinutos||15} minutos, monitora a pasta de entrada. Ao encontrar arquivos .ret ou .txt, processa o retorno CNAB (Sicoob/EFÍ), executa a baixa e move o arquivo para a pasta de saída.
                      </div>
                    </div>
                  </div>
                )}

                {msg && (
                  <div className={`alert py-2 mt-3 ${msg.startsWith("✅")?"alert-success":msg.startsWith("⏳")?"alert-info":"alert-danger"}`} style={{fontSize:13}}>
                    {msg}
                  </div>
                )}

                {/* Botões */}
                <div className="d-flex gap-2 mt-3">
                  <button className="btn btn-primary" onClick={salvar} disabled={saving}>
                    {saving ? <><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>
                      : <><i className="bi bi-floppy me-2"/>Salvar</>}
                  </button>
                  <button className="btn btn-outline-secondary" onClick={executarManual}
                    disabled={executando||!jobAtual?.id}>
                    {executando ? <><span className="spinner-border spinner-border-sm me-2"/>Executando...</>
                      : <><i className="bi bi-play-circle me-2"/>Executar Agora</>}
                  </button>
                  <button className="btn btn-outline-secondary ms-auto"
                    onClick={()=>carregarLogs(jobAtual?.nmJob)}>
                    <i className="bi bi-list-ul me-1"/>Ver Logs
                  </button>
                </div>
              </div>

              {/* Logs */}
              <div className="form-section">
                <div style={{fontWeight:700,fontSize:13,color:"#1B3A6B",marginBottom:12}}>
                  <i className="bi bi-list-ul me-2"/>Histórico de Execuções
                </div>
                {loadingLogs ? (
                  <div style={{textAlign:"center",padding:20}}><span className="spinner-border text-primary"/></div>
                ) : logs.length===0 ? (
                  <div style={{textAlign:"center",padding:30,color:"var(--gray-400)",fontSize:13}}>
                    <i className="bi bi-clock-history" style={{fontSize:32,display:"block",marginBottom:8}}/>
                    Clique em "Ver Logs" para carregar o histórico
                  </div>
                ) : (
                  <div style={{maxHeight:400,overflowY:"auto"}}>
                    {logs.map((log,i)=>{
                      const badge = STATUS_BADGE[log.status]||STATUS_BADGE.Aguardando;
                      return (
                        <div key={i} style={{borderBottom:"1px solid var(--border-subtle)",padding:"10px 0",fontSize:12}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                            <span style={{color:"var(--gray-500)"}}>{fmtDT(log.dtExecucao)}</span>
                            <span style={{padding:"2px 8px",borderRadius:10,fontWeight:700,fontSize:11,background:badge.bg,color:badge.color}}>
                              {log.status}
                            </span>
                          </div>
                          <div style={{color:"var(--gray-600)"}}>
                            ✅ {log.qtdProcessados} baixados &nbsp;
                            {log.qtdErros>0 && <span style={{color:"#DC2626"}}>❌ {log.qtdErros} erros</span>}
                          </div>
                          {log.detalhes && (
                            <pre style={{fontSize:10,background:"var(--bg-surface-alt)",borderRadius:4,padding:"6px 8px",marginTop:6,maxHeight:100,overflowY:"auto",color:"var(--gray-600)"}}>
                              {log.detalhes}
                            </pre>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
